import { render } from "./DeletedPage.vue?vue&type=template&id=7366b91d"
import script from "./DeletedPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DeletedPage.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Insights/DeletedPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7366b91d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7366b91d', __exports__)) {
    api.reload('7366b91d', __exports__)
  }
  
  module.hot.accept("./DeletedPage.vue?vue&type=template&id=7366b91d", () => {
    api.rerender('7366b91d', render)
  })

}


export default __exports__